<div class="container-import">
    <ng-container *ngIf="files.length === 0">
        <div class="dropzone" fileDragDrop (filesChangeEmiter)="onFileChange($event, true)" >
            <div class="text-wrapper">
                <div class="centered d-flex jc-center">
                    <i class="icon-upload"></i>
                    <input type="file" name="file" id="file" (change)="onFileChange($event)" [accept]="acceptFile"/>
                    <label for="file" class="label-file">Selecciona el archivo o arrastra y suelta aquí los archivos</label>
                </div>
            </div>
        </div>
    </ng-container>
    <div class="row fileItem" *ngFor="let f of files; let ind = index">
        <div class="col-sm-12 fileItemText">
            <span>{{f.name}}</span>
        </div>
        <div class="col-sm-12 fileItemIconDiv" (click)="openConfirmDialog(ind);">
          <i class="icon-delete"></i>
       </div>
    </div>
</div>
